const parseCustomizerImages = (images) => {
  return images.map((image) => {
    const start = image.src.indexOf("CUSTOMIZER_");
    const end = image.src.lastIndexOf(".");
    const sub = image.src.substring(start, end);
    const split = sub.split("_");
    return {
      src: image.src,
      thumbnail: image.url,
      width: image.width,
      height: image.height,
      color: split[2],
      size: split[3],
      view: split[4].toLowerCase(),
    };
  });
};

const parseOptions = (options) => {
  return Object.fromEntries(options.map((option) => [option.name.toLowerCase(), option.values]));
};

const getVariantImages = (images, color, size) => {
  const order = ["front", "back", "left", "right"];
  return images
    .filter(
      (image) => image.color === color.replaceAll(" ", "-") && image.size === size.split(" ")[0]
    )
    .sort((a, b) => order.indexOf(a.view) - order.indexOf(b.view));
};

const getVariantPPI = (variant, images) => {
  const front = images.find((image) => image.view === "front");
  const heightPx = front ? front.height : 0;
  const heightIn = variant.height ? parseFloat(variant.height.value) : 0;
  return heightPx / heightIn;
};

const ParseProduct = (product, images) => {
  const productImages = parseCustomizerImages(images);
  const productVariants = product.variants.map((variant) => {
    const variantColor = variant.selectedOptions.find((option) => option.name === "Color").value;
    const variantSize = variant.selectedOptions.find((option) => option.name === "Size").value;
    const variantOptions = parseOptions(variant.selectedOptions);
    const variantFeaturedImage = variant.image ? variant.image.url : "";
    const variantImages = getVariantImages(productImages, variantColor, variantSize);
    const variantZones = variant.zones ? JSON.parse(variant.zones.value) : [];
    // const variantHeight = variant.height ? parseFloat(variant.height.value) : 0;
    // const variantWidth = variant.width ? parseFloat(variant.width.value) : 0;
    const variantPPI = getVariantPPI(variant, variantImages);
    const variantUnderThree = variant.underThree ? variant.underThree.value === "true" : false;
    return {
      ...variantOptions,
      id: variant.id,
      title: variant.title,
      price: parseFloat(variant.price.amount),
      color: variantColor,
      size: variantSize,
      featuredImage: variantFeaturedImage,
      images: variantImages,
      zones: variantZones,
      // height: variantHeight,
      // width: variantWidth,
      ppi: variantPPI,
      underThree: variantUnderThree,
    };
  });
  const productOptions = parseOptions(product.options);
  const productPointsIncluded = product.pointsIncluded ? parseInt(product.pointsIncluded.value) : 0;
  return {
    id: product.id,
    title: product.title,
    productType: product.productType,
    onlineStoreUrl: product.onlineStoreUrl,
    variants: productVariants,
    options: productOptions,
    pointsIncluded: productPointsIncluded,
  };
};

export default ParseProduct;
